import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from "@angular/common/http";
import { AuthGuardService } from '../../shared/services/auth-guard.service';
import {config} from '../../shared/smartadmin.config';
import { Observable } from "rxjs/Observable";
import { environment } from 'environments/environment';

@Injectable()
export class JsonApiService {
    constructor(private http: HttpClient,
        private auth: AuthGuardService
    ) { }

   
public fetch(url): Observable<any>{
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    if (this.auth.isAuthenticated()) {
        let jwtHelper = this.auth.getJwtHelper();
        headers = headers.set('Authorization', 'Bearer ' + jwtHelper.tokenGetter());
    }
    return this.http.get(environment.apiUrl + url, {headers: headers })
    .delay(100)
    .map((data: any)=>(data.data|| data))
}

public post(url, data: any): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    if (this.auth.isAuthenticated()) {
        let jwtHelper = this.auth.getJwtHelper();
        headers = headers.set('Authorization', 'Bearer ' + jwtHelper.tokenGetter());
    }
    return this.http.post(environment.apiUrl + url, data, { headers: headers })
          .delay(100)
          .map((data: any) => (data.data || data))
  }
}





// WEBPACK FOOTER //
// ./src/app/core/api/json-api.service.ts